import { getMethod, postMethod, putMethod, deleteMethod } from "../../api-service/api-service";
import {
    setPartners,
    setLoading,
    addPartner,
    updatePartner,
    removePartner,
    setError
} from "./collectionPartnerSlice";

/* ================= FETCH ALL ================= */
export const fetchCollectionPartners = () => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const res = await getMethod("/collection-partner");

        if (res.success) {
            dispatch(setPartners(res.partners));
        }
        dispatch(setLoading(false));
    } catch (error) {
        dispatch(setError(error.message));
        dispatch(setLoading(false));
    }
};

/* ================= CREATE ================= */
export const createCollectionPartnerAction = (data) => async (dispatch) => {
    try {
        const res = await postMethod("/collection-partner", data);
        if (res.success) {
            dispatch(addPartner(res.partner));
        }
        return res;
    } catch (error) {
        dispatch(setError(error.message));
        return { success: false };
    }
};

/* ================= UPDATE ================= */
export const updateCollectionPartnerAction = (id, data) => async (dispatch) => {
    try {
        const res = await putMethod(`/collection-partner/${id}`, data);
        if (res.success) {
            dispatch(updatePartner(res.partner));
        }
        return res;
    } catch (error) {
        dispatch(setError(error.message));
        return { success: false };
    }
};

/* ================= DELETE ================= */
export const deleteCollectionPartnerAction = (id) => async (dispatch) => {
    try {
        const res = await deleteMethod(`/collection-partner/${id}`);
        if (res.success) {
            dispatch(removePartner(id));
        }
        return res;
    } catch (error) {
        dispatch(setError(error.message));
        return { success: false };
    }
};
